var map = {
	"./asset-hyperlink.json": 82770,
	"./blockquote.json": 33741,
	"./document.json": 33847,
	"./embedded-asset-block.json": 96609,
	"./embedded-entry-block.json": 55751,
	"./embedded-entry-inline.json": 86228,
	"./embedded-resource-block.json": 47086,
	"./embedded-resource-inline.json": 34139,
	"./entry-hyperlink.json": 99304,
	"./heading-1.json": 87973,
	"./heading-2.json": 10803,
	"./heading-3.json": 50766,
	"./heading-4.json": 18806,
	"./heading-5.json": 38256,
	"./heading-6.json": 18856,
	"./hr.json": 92760,
	"./hyperlink.json": 13223,
	"./list-item.json": 54966,
	"./ordered-list.json": 24420,
	"./paragraph.json": 35018,
	"./resource-hyperlink.json": 48623,
	"./table-cell.json": 30924,
	"./table-header-cell.json": 21262,
	"./table-row.json": 58686,
	"./table.json": 1764,
	"./text.json": 94350,
	"./unordered-list.json": 59478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16079;